import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { LicensePlateResponseModel } from '../../../../../modules/inventory/features/license-plate/models/response-models/license-plate-response.model';
import { LpItemsQuantityService } from '../../../../../modules/inventory/features/license-plate/services/lp-items-quantity.service';
import { ProductResponseModel } from '../../../../../modules/products-catalog/models/response-models/product-response.model';
import { TransferScope, WeightUnits } from '../../../../enums/enum';
import { TpmItemsProcessorService } from '../../../../services/tpm-items-processor.service';
import { weightToKg } from '../../../../utility/unit-conversion.util';
import { DispatchBoxMetricsResult } from '../../models/transfer-dispatchbox-allocation.model';
import { TransferDispatchBoxResponse } from '../../models/transfer-dispatchbox.model';

@Component({
  selector: 'app-task-card',
  standalone: false,
  templateUrl: './task-card.component.html',
  styleUrl: './task-card.component.css',
})
export class TaskCardComponent {
  @Input() item: any;
  @Input() requiredQuantity: number = 0;
  @Input() product: ProductResponseModel = new ProductResponseModel();
  @Input() remainQuantity: number = 0;
  @Input() pickedQuantity: number = 0;
  @Input() orderType: string = 'any';
  @Input() qtyLable: string = 'Required ';
  @Input() readyLable: string = 'Picked';
  @Input() remainLable: string = 'Remaining ';
  @Input() showLocatoin: boolean = false;
  @Input() currentIndex: number = 0;
  @Input() itemsLength: number = 0;
  @Input() Scope: TransferScope = TransferScope.Unknown;
  @Input() workDuration: number | null = null;
  @Input() selectedTransferDispatchBox: TransferDispatchBoxResponse = new TransferDispatchBoxResponse();
  @Input() matrix: DispatchBoxMetricsResult = new DispatchBoxMetricsResult();
  @Input() showTimer: boolean = true;
  @Output() workDurationChange = new EventEmitter<number>();
  @Output() onSelect = new EventEmitter<string>();
  
  timerInterval: any;
  isRunning = false;
  transferScope = TransferScope;
  progress: number = 0;
  isPaused: boolean = false;

  constructor(
    private tpmItemsProcessorService: TpmItemsProcessorService,
    private lpItemsQuantityService: LpItemsQuantityService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pickedQuantity'] || changes['requiredQuantity'] || changes['item']) {
      const sessionRequired =
        this.requiredQuantity > 0 ? this.requiredQuantity : this.item?.quantity || 0;

      this.remainQuantity = Math.max(sessionRequired - this.pickedQuantity, 0);

      if (sessionRequired > 0) {
        const calculatedProgress = Math.round((this.pickedQuantity / sessionRequired) * 100);
        this.progress = Math.min(calculatedProgress, 100);
      } else {
        this.progress = 0;
      }
    }
  }

  ngOnInit() {
    this.workDuration ??= 0;
    if (this.showTimer) {
      this.startTimer();
    }
  }

  ngOnDestroy() {
    this.clearTimer();
  }
  startTimer() {
    if (!this.isRunning) {
      this.isRunning = true;
      this.timerInterval = setInterval(() => {
        if (this.workDuration != null) {
          this.workDuration++;
          this.workDurationChange.emit(this.workDuration);
        }
      }, 1000);
    }
  }

  toggleTimer() {
    if (this.isRunning) {
      this.clearTimer();
    } else {
      this.startTimer();
    }
  }

  clearTimer() {
    clearInterval(this.timerInterval);
    this.isRunning = false;
  }

  formatTime(seconds: number | null): string {
    if (seconds == null) return '00:00:00';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`;
  }

  pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  selectBox() {
    this.onSelect.emit();
  }
  getWeightInKg(value: number, unit: WeightUnits): number {
    return weightToKg(value, unit);
  }

  getShortProductName(productName: string | null): string {
    return this.tpmItemsProcessorService.extractProductName(productName ?? '');
  }

  getLicensePlateItemsQuantity(LicensePlate: LicensePlateResponseModel | null): number {
    return this.lpItemsQuantityService.getLicensePlateItemsQuantity(LicensePlate);
  }
}
